import { HoruzError } from '../../../../errors/error.js';
import { HoruzProtocolChulakCloseCode } from '../../codes.js';

/**
 * Error
 * @public
 */
export class HoruzProtocolChulakErrorAppCancel extends HoruzError {
  constructor(reason?: string) {
    super(HoruzProtocolChulakCloseCode.APP_CANCEL, reason);
  }
  /**
   * Constructs error
   * @param reason Reason
   * @returns Error
   */
  static Create(reason?: string) {
    return new this(reason);
  }
}
